import { Box, Modal, Typography } from '@mui/material';
import { useUpdatePrompt, useGetPrompt } from 'apis/agency/prompt/hook';
import Spinner from 'components/Common/Spinner';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import Grid from '@mui/material/Grid2';
import Input from 'components/Common/Input';
import Button from 'components/Common/Button';

export default function PromptForm() {
  const { promptId } = useParams();
  const navigate = useNavigate();
  const { data: prompt, isLoading } = useGetPrompt();

  const { handleSubmit, control } = useForm({
    values: { prompt }
  });

  const { mutate: handlePrompt } = useUpdatePrompt();

  const onSubmit = (data?: any) => {
    handlePrompt(data);
  };

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Modal
      open={true}
      onClose={() => navigate(-1)}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        <Typography variant='h6'> {promptId ? 'Edit Prompt' : 'Add Prompt'}</Typography>

        <Box component='form' onSubmit={handleSubmit(onSubmit)} mt={3}>
          <Grid container spacing='26px' marginTop={2}>
            <Grid size={12}>
              <Input name='prompt.text' label='Text' control={control} fullWidth required multiline minRows={18} />
            </Grid>
          </Grid>
          <Box display='flex' justifyContent='end' gap={2} mt={3}>
            <Button
              color='secondary'
              variant='outlined'
              sx={{ border: '1px solid #F3F3F3' }}
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
            <Button variant='contained' type='submit'>
              {promptId ? 'Save' : 'Add'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '1px solid #F3F3F3',
  boxShadow: 24,
  p: 4,
  borderRadius: '8px',
  maxHeight: '90vh',
  overflow: 'auto',
  width: '90vw'
};
